import { appointmentInPastErrorSchema, slotConflictErrorSchema } from '@/schemas/booking-error.schema.ts';

import { dayjs } from '@/utils/dayjsSetup.ts';

interface BookingErrorOptions {
    err: unknown;
    defaultMessage: string;
}

export const resolveBookingErrorMessage = ({ err, defaultMessage }: BookingErrorOptions): string => {
    const pastDate = appointmentInPastErrorSchema.safeParse(err);
    if (pastDate.success) {
        return 'Der ausgewählte Termin liegt in der Vergangenheit und kann daher nicht gebucht werden. Bitte wählen Sie einen anderen Termin in der Zukunft.';
    }

    const conflict = slotConflictErrorSchema.safeParse(err);
    if (!conflict.success) return defaultMessage;

    const date = dayjs(conflict.data.details.slot);
    if (!date.isValid()) return defaultMessage;

    return `Die Terminbuchung ist fehlgeschlagen. Der Termin ${date.local().format('DD.MM.YYYY HH:mm')} ist leider nicht mehr verfügbar.`;
};
